import React, { useState, useEffect } from "react";
import FacebookIcon from './img/FacebookIcon.png';
import InstagramIcon from './img/InstagramIcon.png';
import LinkedinIcon from './img/LinkedinIcon.png';
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import languageData from './traducao.json'; 

const Fundadores = ({ data = [] }) => {
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("siteLanguage") || 'pt'); 
    const navigate = useNavigate();

    useEffect(() => {
        const browserLanguage = navigator.language.split('-')[0];
        const supportedLanguages = ['pt', 'en', 'es'];

        if (!localStorage.getItem("siteLanguage")) {
            if (supportedLanguages.includes(browserLanguage)) {
                setCurrentLanguage(browserLanguage);
                localStorage.setItem("siteLanguage", browserLanguage);
            } else {
                setCurrentLanguage('pt');
                localStorage.setItem("siteLanguage", 'pt');
            }
        }
    }, []);

    const translations = languageData[currentLanguage];

    const handleClick = () => {
        navigate("/membros");
        window.scrollTo(0, 0);
    };

    return (
        <div className="bg-[linear-gradient(to_right,rgba(208,106,120,0.8),rgba(200,85,122,0.8),rgba(150,74,174,0.8),rgba(198,175,229,0.8))] mb-[5%] flex justify-center items-center">
            <Swiper
                modules={[Navigation, Pagination, A11y]}
                spaceBetween={100}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
            >
                {data.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div className="w-[100%] flex flex-row flex-wrap p-[30px] rounded-[53px] justify-center items-center">
                            <div className="p-[10px]">
                                <img className="max-w-[250px] h-auto" src={item.image} alt={item.nome} />
                            </div>
                            <div className="mx-[5%]">
                                <div className="text-left">
                                    <p className="text-[24px] font-bold text-white">{item.titulos}</p>
                                    <p className="text-[34px] font-extrabold text-white">{item.nome}</p>
                                    <p className="text-[24px] font-bold text-[#353535]">{item.cargo}</p>

                                    <div className="flex gap-2 mt-[10px]">
                                        {item.facebook && (
                                            <a href={item.facebook} target="_blank" rel="noopener noreferrer">
                                                <img className="max-w-[60px]" src={FacebookIcon} alt="Facebook" />
                                            </a>
                                        )}
                                        {item.instagram && (
                                            <a href={item.instagram} target="_blank" rel="noopener noreferrer">
                                                <img className="max-w-[60px]" src={InstagramIcon} alt="Instagram" />
                                            </a>
                                        )}
                                        {item.linkedin && (
                                            <a href={item.linkedin} target="_blank" rel="noopener noreferrer">
                                                <img className="max-w-[60px]" src={LinkedinIcon} alt="LinkedIn" />
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="rounded-[10px] mt-[20px] bg-white w-[12em] h-[2.5em] text-[#353535] font-bold text-[20px] flex justify-center items-center hover:text-white hover:bg-[#B040B1] cursor-pointer"
                                    onClick={handleClick}
                                >
                                    <p>{translations.ourTeam}</p>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Fundadores;
